// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.ConversationPopup_scroll__1kJVs::-webkit-scrollbar {
  height: 8px;
}
.ConversationPopup_scroll__1kJVs::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.ConversationPopup_scroll__1kJVs::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.ConversationPopup_ConversationPopupWrapper__YDi1f {
  background-color: var(--errorBoundBgColor);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 999;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__54byQ {
  background-color: var(--bgColor);
  width: 915px;
  border: 1px solid var(--borderColor);
  min-height: 400px;
  max-height: 700px;
  padding: 10px;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__MediaBox__dN9h- .ConversationPopup_defaultImg__nJR2u {
  width: 100%;
  height: 100%;
  background-color: var(--bodyColor);
  display: flex;
  justify-content: center;
  align-items: center;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__MediaBox__dN9h- .ConversationPopup_defaultImg__nJR2u svg path {
  fill: var(--borderColor);
  stroke: var(--borderColor);
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__MediaBox__dN9h- img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__MediaBox__VideoWrapper__OdfWJ {
  position: relative;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__MediaBox__VideoWrapper__OdfWJ img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__MediaBox__VideoWrapper__OdfWJ div {
  background-color: var(--bgColor);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  z-index: 1000;
  transform: translate(-50%, 50%);
  cursor: pointer;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__MediaBox__VideoWrapper__OdfWJ div svg {
  margin: 10px;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__PostContentBox__24xwO {
  padding: 10px;
  overflow-y: auto;
  max-height: 450px;
  height: 100%;
  position: relative;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__PostContentBox__24xwO .ConversationPopup_commentsWrapper__nRcKY {
  margin-top: -20px;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__PostContentBox__24xwO .ConversationPopup_commentsWrapper__nRcKY .ConversationPopup_commentList__2XaXz {
  padding: 0 10px;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__PostContentBox__24xwO .ConversationPopup_commentsWrapper__nRcKY .ConversationPopup_commentList__2XaXz .ConversationPopup_repliesList__sq4DR {
  -webkit-margin-start: 52px;
          margin-inline-start: 52px;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__PostContentBox__24xwO .ConversationPopup_commentsWrapper__nRcKY .ConversationPopup_commentList__2XaXz .ConversationPopup_commentRow__mZlPZ {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__54byQ .MuiAccordion-root {
  margin-top: 0;
  border: 0;
  min-height: 0 !important;
  min-height: initial !important;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__54byQ .MuiPaper-elevation1 {
  box-shadow: none;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__54byQ .MuiButtonBase-root {
  justify-content: flex-start !important;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__54byQ .MuiAccordionSummary-root {
  min-height: 0;
  min-height: initial;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__54byQ .MuiAccordionSummary-root.Mui-expanded {
  min-height: 0;
  min-height: initial;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__54byQ .MuiAccordionDetails-root {
  flex-direction: column !important;
  padding: 0 !important;
  gap: 10px;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__54byQ .MuiAccordionSummary-content {
  margin: 0;
  flex-grow: initial;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ConversationPopup__54byQ .MuiAccordionSummary-content.Mui-expanded {
  margin: 0;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ViewHideReplies__j5uHh {
  display: flex;
  align-items: center;
  font-size: 10px;
  line-height: 16px;
  font-weight: 400;
  gap: 5px;
  color: var(--tweetSubTitleColor);
  margin-block: 10px;
  text-transform: capitalize;
}
.ConversationPopup_ConversationPopupWrapper__YDi1f .ConversationPopup_ViewHideReplies__borderStart__XshQi {
  width: 22px;
  height: 1px;
  background-color: var(--borderColor);
}

.ConversationPopup_Hidden__Sz8eg {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/ConversationPopup/ConversationPopup.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AApDA;EACE,0CAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAuDF;AAtDE;EACE,gCAAA;EACA,YAAA;EACA,oCAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;AAwDJ;AArDM;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAuDR;AArDU;EACE,wBAAA;EACA,0BAAA;AAuDZ;AAnDM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAqDR;AAnDM;EACE,kBAAA;AAqDR;AAnDQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAqDV;AAnDQ;EACE,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,+BAAA;EACA,eAAA;AAqDV;AApDU;EACE,YAAA;AAsDZ;AAjDI;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAmDN;AAlDM;EACE,iBAAA;AAoDR;AAnDQ;EACE,eAAA;AAqDV;AApDU;EACE,0BAAA;UAAA,yBAAA;AAsDZ;AApDU;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AAsDZ;AAhDM;EACE,aAAA;EACA,SAAA;EACA,wBAAA;EAAA,8BAAA;AAkDR;AAhDM;EACE,gBAAA;AAkDR;AAhDM;EACE,sCAAA;AAkDR;AAhDM;EACE,aAAA;EAAA,mBAAA;AAkDR;AAjDQ;EACE,aAAA;EAAA,mBAAA;AAmDV;AAhDM;EACE,iCAAA;EACA,qBAAA;EACA,SAAA;AAkDR;AA/CM;EACE,SAAA;EACA,kBAAA;AAiDR;AAhDQ;EACE,SAAA;AAkDV;AA7CE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,QAAA;EACA,gCAAA;EACA,kBAAA;EACA,0BAAA;AA+CJ;AA9CI;EACE,WAAA;EACA,WAAA;EACA,oCAAA;AAgDN;;AA5CA;EACE,wBAAA;AA+CF","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n.ConversationPopupWrapper {\n  background-color: var(--errorBoundBgColor);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  z-index: 999;\n  .ConversationPopup {\n    background-color: var(--bgColor);\n    width: 915px;\n    border: 1px solid var(--borderColor);\n    min-height: 400px;\n    max-height: 700px;\n    padding: 10px;\n\n    &__MediaBox {\n      .defaultImg {\n        width: 100%;\n        height: 100%;\n        background-color: var(--bodyColor);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        svg {\n          path {\n            fill: var(--borderColor);\n            stroke: var(--borderColor);\n          }\n        }\n      }\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n      &__VideoWrapper {\n        position: relative;\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n        div {\n          background-color: var(--bgColor);\n          width: 35px;\n          height: 35px;\n          border-radius: 50%;\n          position: absolute;\n          display: block;\n          top: 50%;\n          left: 50%;\n          z-index: 1000;\n          transform: translate(-50%, 50%);\n          cursor: pointer;\n          svg {\n            margin: 10px;\n          }\n        }\n      }\n    }\n    &__PostContentBox {\n      padding: 10px;\n      overflow-y: auto;\n      max-height: 450px;\n      height: 100%;\n      position: relative;\n      .commentsWrapper {\n        margin-top: -20px;\n        .commentList {\n          padding: 0 10px;\n          .repliesList {\n            margin-inline-start: 52px;\n          }\n          .commentRow {\n            display: flex;\n            justify-content: space-between;\n            align-items: flex-start;\n          }\n        }\n      }\n    }\n    :global {\n      .MuiAccordion-root {\n        margin-top: 0;\n        border: 0;\n        min-height: unset !important;\n      }\n      .MuiPaper-elevation1 {\n        box-shadow: none;\n      }\n      .MuiButtonBase-root {\n        justify-content: flex-start !important;\n      }\n      .MuiAccordionSummary-root {\n        min-height: unset;\n        &.Mui-expanded {\n          min-height: unset;\n        }\n      }\n      .MuiAccordionDetails-root {\n        flex-direction: column !important;\n        padding: 0 !important;\n        gap: 10px;\n      }\n\n      .MuiAccordionSummary-content {\n        margin: 0;\n        flex-grow: unset;\n        &.Mui-expanded {\n          margin: 0;\n        }\n      }\n    }\n  }\n  .ViewHideReplies {\n    display: flex;\n    align-items: center;\n    font-size: 10px;\n    line-height: 16px;\n    font-weight: 400;\n    gap: 5px;\n    color: var(--tweetSubTitleColor);\n    margin-block: 10px;\n    text-transform: capitalize;\n    &__borderStart {\n      width: 22px;\n      height: 1px;\n      background-color: var(--borderColor);\n    }\n  }\n}\n.Hidden {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `ConversationPopup_scroll__1kJVs`,
	"ConversationPopupWrapper": `ConversationPopup_ConversationPopupWrapper__YDi1f`,
	"ConversationPopup": `ConversationPopup_ConversationPopup__54byQ`,
	"ConversationPopup__MediaBox": `ConversationPopup_ConversationPopup__MediaBox__dN9h-`,
	"defaultImg": `ConversationPopup_defaultImg__nJR2u`,
	"ConversationPopup__MediaBox__VideoWrapper": `ConversationPopup_ConversationPopup__MediaBox__VideoWrapper__OdfWJ`,
	"ConversationPopup__PostContentBox": `ConversationPopup_ConversationPopup__PostContentBox__24xwO`,
	"commentsWrapper": `ConversationPopup_commentsWrapper__nRcKY`,
	"commentList": `ConversationPopup_commentList__2XaXz`,
	"repliesList": `ConversationPopup_repliesList__sq4DR`,
	"commentRow": `ConversationPopup_commentRow__mZlPZ`,
	"ViewHideReplies": `ConversationPopup_ViewHideReplies__j5uHh`,
	"ViewHideReplies__borderStart": `ConversationPopup_ViewHideReplies__borderStart__XshQi`,
	"Hidden": `ConversationPopup_Hidden__Sz8eg`
};
export default ___CSS_LOADER_EXPORT___;
